<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row" v-if="customerId || ($store.state.userData.isOrganization && $store.state.role != 'branches')">
                <div class="col-12 mb-2" v-if="Object.keys(legalCustomerDetails).length">
                    <h5>اطلاعات سازمان</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover user-details-table">
                            <tbody>
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12">
                    <nav class="nav nav-tabs mb-3">
                        <a class="nav-link ml-1 active" data-toggle="tab" @click="setCurrentTab('fizical-card')" href="#fizical-card">بن کارت با طرح آماده</a>
                        <a class="nav-link" data-toggle="tab" @click="setCurrentTab('fizical-fizical-card')" href="#fizical-fizical-card">بن کارت با طرح دلخواه</a>
                    </nav>
                    <div class="tab-content">
                        <div class="tab-pane active show" id="fizical-card">
                            <FizicalCard v-if="currentTab == 'fizical-card'" :addToCard="addToCard" :customerId="customerId" />
                        </div>
                        <div class="tab-pane" id="fizical-fizical-card">
                            <CustomCard v-if="currentTab == 'fizical-fizical-card'" :addToCard="addToCard" :customerId="customerId" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="domain">سازمان</label>
                        <Vselect @input="searchCustomer" v-model="nationalCode" :reduce="item => item.nationalId" label="title" :options="organizations">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code">شناسه ملی</label>
                        <div class="input-group">
                            <input class="form-control text-left" maxlength="11" id="national-code" type="tel" v-model="nationalCode">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FizicalCard from './Cards/FizicalCard';
import CustomCard from './Cards/CustomCard';
export default {
    name: 'Create',
    components: {FizicalCard,CustomCard},
    data(){
        return {
            nationalCode: '',
            legalCustomerDetails: {},
            customerId: 0,
            maxLength: 10,
            basket: [],
            currentTab: 'fizical-card',
            organizations: [],
            showLoading: true
        }
    },
    methods: {
        getData(){
            const postedData = {
                page: 1,
                perPage: 500
            };
            this.$api.post('Management/organizations/List',postedData).then(({data}) => {
                let organizations = [];
                data.result.list.map(item => {
                    if(item.domainMetaData)
                        organizations.push({
                            title: item.domainMetaData.companyNameFa,
                            nationalId: item.domainMetaData.nationalId
                        });
                });
                this.organizations = organizations;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        setCurrentTab(tab){
            this.currentTab = tab;
        },
        addToCard(themeId,title,cardType,imageUrl,csvFile){
            console.log(themeId,title,cardType,imageUrl,csvFile);
        },
        calcTotalPrice(){
            let totalPrice = 0;
            let depositAmount = 0;
            this.chargesPrice = 0;
            this.cardsPrice = 0;
            let getDeposit;
            this.basket.map(item => {
                depositAmount = 0;
                if(item.depositId && item.depositId != 41){
                    if(item.depositId == 61)
                        depositAmount += (parseInt(item.optionalCredit) * item.itemsCount);
                    else{
                        getDeposit = this.depositsList.filter(deposit => deposit.depositId == item.depositId)[0];
                        depositAmount += (parseInt(getDeposit.depositValue) * item.itemsCount);
                    }
                }
                this.cardsPrice += (item.price * item.itemsCount);
                this.chargesPrice += depositAmount;
                totalPrice += (item.price * item.itemsCount) + depositAmount;
            });
            this.totalPrice = totalPrice;
            let discount = parseInt(this.discount.toString().replace(/,/g,''));
            if(totalPrice > discount)                
                this.displayedTotalPrice = totalPrice - discount;
            else
                this.displayedTotalPrice = 0;
        },
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.legalCustomerDetails = data.result;
                    this.setCurrentTab('fizical-card');
                }
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        removeCard(itemIndex){
            let basket = this.basket.filter((item,index) => index != itemIndex);
            this.basket = basket;
            this.calcTotalPrice();
        },
        discountNumberFormat(){
            let value = this.discount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.discount = value;
        },
        changeCustomerType(){
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            this.maxLength = this.customerType == 1 ? 10 : 11;
            this.nationalCode = '';
        },
        submit(){
            this.$swal({
                icon: 'warning',
                title: 'توجه !',
                text: 'آیا از ثبت سفارش اطمینان دارید ؟',
                confirmButtonText: 'ثبت سفارش',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then((result) => {
                if(result.isConfirmed){
                    this.showLoading = true;
                    const postedData = {
                        items: this.basket,
                        isAdmin: true,
                        customerId: this.customerId
                    };
                    this.$api.post('Organizations/Orders',postedData).then(({data}) => {
                        if(data.status)
                            this.$swal({
                                icon: 'success',
                                title: 'تبریک !',
                                text: 'ثبت سفارش با موفقیت انجام شد',
                            }).then(res => {
                                if(res.isConfirmed){
                                    this.$router.push({path: '/?today=true'});
                                }
                            });
                    }).catch(({response}) => {
                        let html = '';
                        response.data.errors.map(err => html += err.message + '<br>');
                        this.$swal({
                            icon: 'error',
                            title: 'خطا !',
                            html
                        });
                    }).finally(() => {
                        this.showLoading = false;
                    });
                }else
                    this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>
